import React from 'react';

var UserInfo = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'user-info' }, children);
};

export { UserInfo };
